module.exports = __webpack_public_path__ + "img/sy_n3_1.148dbefc.jpeg";